import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { ModalDialog } from '../../../../components/common/Dialogs'
import { SpacingContainer } from '../../../../components/common/Containers'
import { TextField } from '../../../../components/common/Inputs'
import { Button } from '../../../../components/common/Buttons'
import { useTrans } from '../../../../services/i18n'
import { useAlertContext } from '../../../../contexts/AlertContext'

const INITIAL_FORM = { agencyId: '', govLink: '', smallBusinessLink: '' }

export default function SetupAgencyModal({
  open,
  onClose,
  updateAgencyLink,
  afterSave
}) {
  const { trans } = useTrans()
  const { successAlert, errorAlert } = useAlertContext()
  const [isSending, setIsSending] = useState(false)
  const [form, setForm] = useState(INITIAL_FORM)

  // Reset inputs each time the modal is opened
  useEffect(() => {
    if (open) {
      setForm(INITIAL_FORM)
      setIsSending(false)
    }
  }, [open])

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSave = async () => {
    // Require at least one link
    if (!form.govLink && !form.smallBusinessLink) {
      errorAlert(trans('please-enter-at-least-one-link'))
      return
    }

    setIsSending(true)
    try {
      // Build payload; include only provided keys so backend can distinguish
      const payload = { agencyId: form.agencyId }
      if (form.govLink !== '') payload.govLink = form.govLink
      if (form.smallBusinessLink !== '') payload.smallBusinessLink = form.smallBusinessLink

      await updateAgencyLink(payload)
      successAlert(trans('resource-updated'))
      setForm(INITIAL_FORM)
      afterSave()
    } catch {
      errorAlert(trans('error-saving'))
    } finally {
      setIsSending(false)
    }
  }

  const handleCancel = () => {
    setForm(INITIAL_FORM)
    setIsSending(false)
    onClose()
  }

  return (
    <ModalDialog
      open={open}
      onClose={handleCancel}
      title={trans('add-agency-link')}
      actions={
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button variant="outlined" onClick={handleCancel} disabled={isSending}>
              {trans('cancel')}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success" pending={isSending} onClick={handleSave}>
              {trans('save')}
            </Button>
          </Grid>
        </Grid>
      }
    >
      <SpacingContainer px={3} py={2}>
        <TextField
          fullWidth
          label={trans('agency-id')}
          name="agencyId"
          value={form.agencyId}
          onChange={handleChange}
          style={{ marginBottom: '16px' }}
        />
        <TextField
          fullWidth
          label={trans('agency-link')}
          name="govLink"
          value={form.govLink}
          onChange={handleChange}
          style={{ marginBottom: '16px' }}
        />
        <TextField
          fullWidth
          label={trans('small-business-link')}
          name="smallBusinessLink"
          value={form.smallBusinessLink}
          onChange={handleChange}
        />
      </SpacingContainer>
    </ModalDialog>
  )
}

